import {
  Box,
  Button,
  Flex,
  Icon,
  IconButton,
  Image,
  Img,
  Input,
  Link,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Skeleton,
  Text,
  useBoolean,
  useBreakpointValue,
  useDisclosure,
  useToast
} from "@chakra-ui/react";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";

import { useAuth, useCart } from "@/contexts";

import { HiOutlineUser } from "react-icons/hi";

import { LoginModal, ModalPneu } from "@/components/Modal";
import { Logo } from "./Logo";
import { useAsynClientById } from "@/hooks/Client";
import { useIsomorphicLayoutEffect } from "@/hooks/Custom";
import { DrawerMenu } from "@/components/Menu/DrawerMenu";
import { useLoading } from "@/contexts/LoadingContext";

import { SmartSearch } from "../SmartSearch";
import { FiMenu } from "react-icons/fi";

export function HeaderDesktop() {
  const isWideVersion = useBreakpointValue({
    base: false,
    xs: false,
    sm: false,
    md: false,
    lg: true,
    xl: true
  });

  const { ActionIsLoading } = useLoading();
  const [search, setSearch] = useState("");
  const [login, setLogin] = useBoolean();
  const [userName, setUserName] = useState("USUÁRIO");
  const User = useAuth();
  const { cartSize } = useCart();

  const router = useRouter();
  const initialFocusRef = useRef();
  const toast = useToast();
  // console.log("search", search);
  const verifyPage = router.route;

  const { asPath } = useRouter();

  function handleCart() {
    router.push("/carrinho");
  }
  function submitFreeSearch(e) {
    e.preventDefault();
    if (search) {
      router.push(`/pesquisa/${encodeURIComponent(search)}`);
      setSearch("");
    } else {
      toast({
        title: "Digite um termo para pesquisar.",
        status: "info",
        position: "bottom",
        duration: 5000,
        isClosable: true
      });
    }
  }
  async function getUserName(clientID: string) {
    const [UserData, UserError] = await useAsynClientById(clientID);
    if (UserData) {
      const IsPF = UserData?.hasOwnProperty("clientPFData");
      const UserName =
        UserData?.[IsPF ? "clientPFData" : "clientPJData"]?.[IsPF ? "name" : "nomeFantasia"]?.split(
          " "
        )[0];
      setUserName(UserName);
    } else {
      setUserName("USUÁRIO");
    }
  }

  useIsomorphicLayoutEffect(() => {
    if (User?.clientId) {
      getUserName(User?.clientId);
    }
  }, [User]);

  const { onOpen, isOpen, onClose } = useDisclosure();

  const [drawerMenu, setDrawerMenu] = useBoolean();

  const [isLoading, setIsloading] = useState<boolean>(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsloading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Flex
      w="full"
      h={"70px"}
      justifyContent={"center"}
      alignItems={"center"}
      bgColor={"ll-white.main"}
    >
      <Flex
        w={["90%", "80%", "1000px", "1200px"]}
        h={"full"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Flex w={"380px"}>
          {isLoading ? (
            <Skeleton w={"35px"} height={"35px"} mr={"10px"} />
          ) : (
            <Img
              cursor={"pointer"}
              onClick={setDrawerMenu.toggle}
              src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/menu-green.svg"}
              mr={"20px"}
            />
          )}
          {isLoading ? (
            <Skeleton w={"150px"} height={"35px"} mr={"10px"} />
          ) : (
            <Flex>
              {!User.isAuthenticated ? (
                <Flex alignItems={"bottom"}>
                  <Img
                    mr={"5px"}
                    src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/user.svg"}
                    w={"18px"}
                    mb={"3px"}
                  />
                  <Text
                    fontWeight={"600"}
                    color={"ll-blue.main"}
                    mr={"18px"}
                    fontSize={"text1"}
                    cursor={"pointer"}
                    onClick={() => router.push("/minhaconta")}
                  >
                    FAZER LOGIN
                  </Text>
                </Flex>
              ) : (
                <Flex alignItems={"center"}>
                  <Img
                    mr={"5px"}
                    src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/user.svg"}
                    w={"18px"}
                  />
                  <Text
                    fontWeight={"600"}
                    color={"ll-blue.main"}
                    mr={"18px"}
                    fontSize={"text1"}
                    cursor={"pointer"}
                    onClick={() => router.push("/minhaconta")}
                  >
                    MINHA CONTA
                  </Text>
                </Flex>
              )}
            </Flex>
          )}

          {isLoading ? (
            <Skeleton w={"160px"} height={"35px"} />
          ) : (
            <Popover isOpen={isOpen} onClose={onClose} placement="bottom-end">
              <PopoverTrigger>
                <Flex
                  alignItems={"bottom"}
                  as={"button"}
                  onClick={() => (isOpen ? onClose() : onOpen())}
                >
                  <Img
                    mr={"5px"}
                    src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/pneu-ico.svg"}
                    w={"25px"}
                    mt={"2px"}
                  />
                  <Text
                    fontWeight={"600"}
                    color={"ll-blue.main"}
                    mr={"24px"}
                    fontSize={"text1"}
                    cursor={"pointer"}
                  >
                    NOSSOS PNEUS
                  </Text>
                </Flex>
              </PopoverTrigger>
              <ModalPneu onClose={onClose} />
            </Popover>
          )}
        </Flex>
        <Link href="/">
          <Img
            src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/ling-long-logo.svg"}
          />
        </Link>

        <Flex w={"380px"} justifyContent={"flex-end"}>
          {isLoading ? (
            <Skeleton w={"200px"} height={"35px"} mr={"10px"} />
          ) : (
            asPath != "/" && (
              <Flex w={"auto"} h={"40px"} mr={"20px"}>
                <SmartSearch
                  Search={search}
                  setSearch={setSearch}
                  closeButtonRef={null}
                  initialFocusRef={initialFocusRef}
                >
                  <Flex
                    onSubmit={submitFreeSearch}
                    as="form"
                    paddingY={"4"}
                    paddingLeft={"4"}
                    alignSelf={"center"}
                    alignItems={"center"}
                    justify={"space-between"}
                    color={"gray.200"}
                    position={"relative"}
                    bg={"white"}
                    h={"40px"}
                    borderRadius={"50px"}
                    borderWidth="1px"
                    borderColor="ll-gray.100"
                    bgColor={"ll-gray.600"}
                    pr={"15px"}
                  >
                    <Input
                      color={"ll-gray.200"}
                      bgColor={"transparent"}
                      width={"180px"}
                      fontSize={"text1"}
                      variant={"unstyled"}
                      _placeholder={{ color: "#58585A" }}
                      role={"dialog"}
                      aria-label="Samrt Search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      placeholder="Pesquisar"
                      ref={initialFocusRef}
                    />
                    <Img
                      src={
                        "https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/ico-search.svg"
                      }
                    />
                  </Flex>
                </SmartSearch>
              </Flex>
            )
          )}

          {isLoading ? (
            <Skeleton w={"35px"} height={"35px"} />
          ) : (
            <Flex>
              {cartSize > 0 ? (
                <Flex
                  zIndex={1}
                  mt={asPath != "/" ? "0px" : "-8px"}
                  marginLeft={"10px"}
                  bgColor={"ll-green.main"}
                  minW={"15px"}
                  h={"15px"}
                  borderRadius={"50px"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  color={"ll-white.main"}
                  fontSize={"10px"}
                  fontWeight={"600"}
                  position={"absolute"}
                >
                  <Text>{cartSize}</Text>
                </Flex>
              ) : null}
              <Img
                minW={"20px"}
                objectFit={"contain"}
                onClick={handleCart}
                cursor={"pointer"}
                src={"https://cdn.pneufree.com.br/LINGLONG/images/Geral/DESKTOP/ico-cart.svg"}
              />
            </Flex>
          )}

          <DrawerMenu
            placement={"left"}
            isOpen={drawerMenu}
            onClose={setDrawerMenu.off}
            DrawerPosition={"desktop"}
          />
        </Flex>
      </Flex>
    </Flex>
  );
}
